import { call, put, takeEvery } from "redux-saga/effects";
import { getCall } from "../../../../helpers/fakebackend_helper";
import { verifyData } from "../../../../pages/Common/CommonFunctions/commonFunctions";
import { GET_ALL_ASSESSMENT_DETAILS, GET_ASSESSMENT_RECORD } from "./actionTypes";
import { getAllAssessmentDetailsFail, getAllAssessmentDetailsSuccess, getAssessmentRecordFail, getAssessmentRecordSuccess } from "./actions";
// Worker Saga: Makes the API call and dispatches success or failure actions
function* fetchAssessmentDetails(data) {
  let requestData = data.payload;
  try {
    let url = "recruitement/assessment/list";
    let pageNumeber = 0;
    let pageSize = 50;
    if (requestData !== undefined && requestData != null) {
      pageNumeber = requestData.pageNumber
        ? requestData.pageNumber
        : pageNumeber;
      pageSize = requestData.pageSize ? requestData.pageSize : pageSize;
    }
    url = url + `?page=${pageNumeber}&pageSize=${pageSize}`;
    if (requestData.sort !== null && requestData.sort !== undefined) {
      url = url + "&sort=" + encodeURIComponent(requestData.sort);
    }
    let extentedUrl;

    if (
      verifyData(requestData.filter) &&
      Object.entries(requestData?.filter).length > 0
    ) {
      extentedUrl = requestData.filter.map((eachObject) => {
        return (
          eachObject.filterName +
          "=" +
          encodeURIComponent(
            eachObject.condition + "[" + eachObject.value + "]"
          )
        );
      });
    }
    if (verifyData(requestData.searchKeyword)) {
      url = url + "&searchKeyword=" + requestData.searchKeyword;
    }
    if(extentedUrl !== undefined && extentedUrl !== null && extentedUrl !== ""){
        url = url+`&${extentedUrl.join("&") }`
      }
    
    const response = yield call(getCall, url);
    yield put(getAllAssessmentDetailsSuccess(response));
  } catch (error) {
    
    yield put(getAllAssessmentDetailsFail(error.message));
  }
}
function* getAssessmentRecordF(data) {
  console.log(data.payload)
  try {
      let url = `recruitement/assessment/detail?assessmentId=${data.payload.id}`;
      let responsJSON = yield call(getCall, decodeURIComponent(url))
      yield put(getAssessmentRecordSuccess(responsJSON))
  }
  catch (error) {
      yield put(getAssessmentRecordFail(error))
  }
}
function* assessmentDetailsSaga() {
  yield takeEvery(GET_ALL_ASSESSMENT_DETAILS, fetchAssessmentDetails);
  yield takeEvery(GET_ASSESSMENT_RECORD, getAssessmentRecordF);
}
export default assessmentDetailsSaga;
